"use strict";
exports.__esModule = true;
exports.handleGeoPushpinDrillEvent = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var data_1 = require("./data");
var without_1 = tslib_1.__importDefault(require("lodash/without"));
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var custom_event_1 = tslib_1.__importDefault(require("custom-event"));
function getDrillIntersectionForGeoChart(drillableItems, dv, geoData, locationIndex) {
    var measureGroupItems = dv.meta().measureDescriptors();
    var measureHeaders = measureGroupItems.slice(0, 2);
    var _a = data_1.findGeoAttributesInDimension(dv, geoData), locationAttribute = _a.locationAttribute, segmentByAttribute = _a.segmentByAttribute, tooltipTextAttribute = _a.tooltipTextAttribute;
    var _b = getAttributeHeader(locationAttribute, locationIndex), locationAttributeHeader = _b.attributeHeader, locationAttributeHeaderItem = _b.attributeHeaderItem;
    var _c = getAttributeHeader(segmentByAttribute, locationIndex), segmentByAttributeHeader = _c.attributeHeader, segmentByAttributeHeaderItem = _c.attributeHeaderItem;
    var _d = getAttributeHeader(tooltipTextAttribute, locationIndex), tooltipTextAttributeHeader = _d.attributeHeader, tooltipTextAttributeHeaderItem = _d.attributeHeaderItem;
    // pin is drillable if a drillableItem matches:
    //   pin's measure,
    //   pin's location attribute,
    //   pin's location attribute item,
    //   pin's segmentBy attribute,
    //   pin's segmentBy attribute item,
    //   pin's tooltipText attribute,
    //   pin's tooltipText attribute item,
    var drillItems = without_1["default"](tslib_1.__spreadArrays(measureHeaders, [
        locationAttributeHeaderItem,
        locationAttributeHeader,
        segmentByAttributeHeaderItem,
        segmentByAttributeHeader,
        tooltipTextAttributeHeaderItem,
        tooltipTextAttributeHeader,
    ]), undefined);
    var drilldown = drillItems.some(function (drillableHook) {
        return sdk_ui_1.isSomeHeaderPredicateMatched(drillableItems, drillableHook, dv);
    });
    if (drilldown) {
        return sdk_ui_1.getDrillIntersection(drillItems);
    }
    return undefined;
}
function getAttributeHeader(attribute, dataIndex) {
    if (attribute) {
        return {
            attributeHeader: { attributeHeader: omit_1["default"](attribute, "items") },
            attributeHeaderItem: attribute.items[dataIndex]
        };
    }
    return {
        attributeHeader: undefined,
        attributeHeaderItem: undefined
    };
}
function handleGeoPushpinDrillEvent(drillableItems, drillConfig, dv, geoData, pinProperties, pinCoordinates, target) {
    var locationIndex = (pinProperties || {}).locationIndex;
    var drillIntersection = getDrillIntersectionForGeoChart(drillableItems, dv, geoData, locationIndex);
    if (!(drillIntersection === null || drillIntersection === void 0 ? void 0 : drillIntersection.length)) {
        return;
    }
    var onDrill = drillConfig.onDrill;
    var lng = pinCoordinates[0], lat = pinCoordinates[1];
    var _a = data_1.parseGeoProperties(pinProperties) || {}, locationNameValue = _a.locationName.value, colorValue = _a.color.value, segmentByValue = _a.segment.value, sizeValue = _a.size.value;
    var drillContext = {
        element: "pushpin",
        intersection: drillIntersection,
        type: "pushpin",
        color: colorValue,
        location: { lat: lat, lng: lng },
        locationName: locationNameValue,
        segmentBy: segmentByValue,
        size: sizeValue
    };
    var drillEventExtended = {
        dataView: dv.dataView,
        drillContext: drillContext
    };
    if (onDrill) {
        var shouldFireEvent = onDrill(drillEventExtended);
        // if user-specified onDrill fn returns false, do not fire default DOM event
        if (shouldFireEvent !== false) {
            var event_1 = new custom_event_1["default"]("drill", {
                detail: drillEventExtended,
                bubbles: true
            });
            target.dispatchEvent(event_1);
        }
    }
}
exports.handleGeoPushpinDrillEvent = handleGeoPushpinDrillEvent;
//# sourceMappingURL=drilling.js.map